import(/* webpackMode: "eager", webpackExports: ["CashbackPage"] */ "/home/nexts/lm-master-front/src/flat-pages/cashback/index.tsx");
